<template>
  <div>
    <el-cascader
      ref="cascader"
      :options="options"
      v-model="roomId"
      filterable
      clearable
      @change="handleRoom"
      :props="{ checkStrictly: true }"
      style="width: 290px"
      popper-append-to-body
      @visible-change="handleVisibleChange"
    >
    </el-cascader>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import { getZfPropertyAll } from "@/api/room.js";
export default {
  data() {
    return {
      options: [],
      roomId: "",
    };
  },
  created() {
    this.getZfPropertyAll();
  },
  methods: {
    handleVisibleChange(visible) {
      if (visible) {
        if (this.loading) {
          const cascaderEl = this.$refs.cascader.$el;
          const popperEl = cascaderEl.querySelector(".el-cascader-panel");
          this.loadingInstance = Loading.service({
            target: popperEl,
            text: "加载中...",
          });
        } else {
          if (this.loadingInstance) {
            this.loadingInstance.close();
          }
        }

        if (!this.observer) {
          this.observer = new MutationObserver((mutations) => {
            this.updatePanelStyles();
          });
        }

        const cascaderPanel = document.querySelector(".el-cascader-panel");
        if (cascaderPanel) {
          this.observer.observe(cascaderPanel, {
            childList: true,
            subtree: true,
          });
        }

        this.updatePanelStyles();
      } else {
        this.loading = false;
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    },
    updatePanelStyles() {
      const cascaderPanel = document.querySelector(".el-cascader-panel");
      if (cascaderPanel) {
        if (this.options.length < 20) {
          cascaderPanel.style.maxHeight = `auto`;
        } else {
          const minHeight = Math.min(this.options.length * 30, 700);
          cascaderPanel.style.minHeight = `${minHeight}px`;
        }
      }
      const cascaderMenu = document.querySelectorAll(".el-cascader-menu");
      cascaderMenu.forEach((menu) => {
        menu.style.width = "11vw";
      });

      const radioStyles = document.querySelectorAll(".el-radio__inner");
      radioStyles.forEach((style) => {
        style.style.border = "0.005rem solid #5757586b";
      });
    },
    handleRoom(arr) {
      // const list = ['zfPropertyId','zfFloorId','zfLevelId','zfRoomId']
      try {
        this.$emit("config", arr);
      } catch (e) {
        this.$emit("config", []);
      }
    },
    getZfPropertyAll() {
      this.loading = true;
      getZfPropertyAll({
        pageNum: 1,
        pageSize: 100,
      }).then((res) => {
        if (res.code == "000000") {
          this.options = this.treeArr(res.data.zfPropertyVoList);
        }
        this.loading = false;
        if (this.loadingInstance) {
          this.loadingInstance.close();
        }
        // this.loadingInstance.close();
      });
    },
    treeArr(arr) {
      for (let i = 0; i < arr.length; i++) {
        let item = arr[i];
        item.value = item.id;
        item.label = item.communityName
          ? item.communityName + " (项目)"
          : item.floorName
          ? item.floorName + " (楼栋)"
          : item.level
          ? item.level + " (楼层)"
          : item.room + " (房间号)";
        item.children = item.zfFloorVoList || item.zfLevelVoList || item.zfRoomVoList;
        if (item.children) {
          this.treeArr(item.children);
        }
      }
      return arr;
    },
  },
};
</script>

<style scoped>
/deep/ .el-cascader {
  max-width: 500px !important;
}

/deep/ .el-cascader-panel {
  height: 400px !important;
  overflow-y: auto !important;
}

/deep/ .el-cascader-menu__wrap {
  height: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/selectRoom/index.vue